/**
 * @module hooks/usePanelActions
 * @description Panel 层操作 — 开/关面板、页签切换（UI 壳，不涉及 draft 写入）
 */

import { useCallback } from 'react';
import { useChartSettingsDispatch } from '../../context';
import { CSActionType } from '../../types';

export interface IPanelActions {
  openPanel: () => void;
  /** 标题栏关闭 — 仅隐藏面板，保留 base / draft */
  dismissPanel: () => void;
  /** Cancel — 丢弃 draft 并关闭面板 */
  cancelPanel: () => void;
  switchTab: (tabId: string) => void;
}

export function usePanelActions(): IPanelActions {
  const dispatch = useChartSettingsDispatch();

  const openPanel = useCallback(() => {
    dispatch({ type: CSActionType.SET_MODAL, payload: true });
    dispatch({ type: CSActionType.SET_ACTIVE_TAB, payload: 'basic' });
  }, [dispatch]);

  const dismissPanel = useCallback(() => {
    dispatch({ type: CSActionType.SET_MODAL, payload: false });
  }, [dispatch]);

  const cancelPanel = useCallback(() => {
    dispatch({ type: CSActionType.RESET_DRAFT });
    dispatch({ type: CSActionType.SET_MODAL, payload: false });
  }, [dispatch]);

  const switchTab = useCallback(
    (tabId: string) => {
      dispatch({ type: CSActionType.SET_ACTIVE_TAB, payload: tabId });
    },
    [dispatch],
  );

  return { openPanel, dismissPanel, cancelPanel, switchTab };
}
